import { render, staticRenderFns } from "./SafeNote.vue?vue&type=template&id=65085b1c&"
import script from "./SafeNote.vue?vue&type=script&lang=js&"
export * from "./SafeNote.vue?vue&type=script&lang=js&"
import style0 from "./SafeNote.vue?vue&type=style&index=0&id=65085b1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports